export default "__VITE_ASSET__6bM73mqL__"